import { Navigate } from 'react-router';
import { Helmet } from 'react-helmet-async';

import { hasPermission } from 'src/utils/has-permissions';

import { useAuthContext } from 'src/auth/hooks';
import { AuthPermissions } from 'src/auth/permissions';

import { BarPurchaseOrdersListView } from 'src/sections/bar-purchases/view';

export default function BarPurchaseListPage() {
  const { user: authUser } = useAuthContext();

  return (
    <>
      <Helmet>
        <title> Kitchen: Purchase Order</title>
      </Helmet>

      {hasPermission(
        authUser,
        'any',
        AuthPermissions.READ_BAR_INVENTORY_TRANSACTION,
        AuthPermissions.ADMIN_PERMISSION,
        AuthPermissions.SUPER_ADMIN_PERMISSION
      ) ? (
        <BarPurchaseOrdersListView />
      ) : (
        <Navigate to="/403" />
      )}
    </>
  );
}
